<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YcrzGI/tc-custom/9781439672525.jpg?1703867466943" alt="This image is the cover for the book George Washington's Long Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">George Washington's Long Island
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1778, two years after the British forced the Continental Army out of New York City, George Washington and his subordinates organized a secret spy network to gather intelligence in Manhattan and Long Island. Known today as the "Culper Spy Ring," Patriots like Abraham Woodhull and Robert Townsend risked their lives to report on British military operations in the region. Vital reports clandestinely traveled from New York City across the East River to Setauket and were rowed on whaleboats across the Long Island Sound to the Connecticut shore. Using ciphers, codes and invisible ink, the spy ring exposed British plans to attack French forces at Newport and a plot to counterfeit American currency. Author Bill Bleyer corrects the record, examines the impact of George Washington's Long Island spy ring and identifies Revolutionary War sites that remain today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill Bleyer
      </h2>
      
      <p class="authorDescription body article">Bill Bleyer was a prize-winning staff writer for Newsday, the Long Island daily newspaper, for thirty-three years before retiring in 2014 to write books and freelance for the newspaper and magazines. He is coauthor, with Harrison Hunt, of Long Island and the Civil War (The History Press, 2015). He is the author of Sagamore Hill: Theodore Roosevelt's Summer White House (The History Press, 2016), The Fire Island Lighthouse: Long Island's Welcoming Beacon (The History Press, 2017) and Long Island and the Sea: A Maritime History (The History Press, 2019). The Long Island native has written extensively about history for newspapers and magazines. In 1997-98, he was one of four Newsday staff writers assigned full time to "Long Island: Our Story," a year-long daily history of Long Island that resulted in three books and filled hundreds of pages in the newspaper. His work has been published in Civil War News, Naval History, Sea History, Lighthouse Digest and numerous other magazines, as well as in the New York Times, Chicago Sun-Times, Toronto Star and other newspapers. Bleyer graduated Phi Beta Kappa with highest honors in economics from Hofstra University, where he has been an adjunct professor teaching journalism and economics. He earned a master's degree in urban studies at Queens College of the City University of New York. An avid sailor, diver and kayaker, he lives in Bayville, Long Island.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5aa82b69